import css from "./LI.module.css";

const LI = ({ center, children, type }) => {
  let icon;

  switch (type) {
    case "none":
      icon = <div className={css.img} />;
      break;
    case "info":
      icon = (
        <img
          src="https://storage.googleapis.com/squidslippers-media/icons/info.png"
          alt="check"
          className={css.img}
        />
      );
      break;
    case "unchecked":
      icon = <div className={css.unchecked} />;
      break;
    case "warning":
      icon = (
        <img
          src="https://storage.googleapis.com/squidslippers-media/icons/warning.png"
          alt="check"
          className={css.img}
          style={{ marginBottom: "0.25rem" }}
        />
      );
      break;
    case "x":
      icon = (
        <img
          src="https://storage.googleapis.com/squidslippers-media/icons/x.png"
          alt="check"
          className={css.img}
        />
      );
      break;
    default: {
      icon = (
        <img
          src="https://storage.googleapis.com/squidslippers-media/icons/check.png"
          alt="check"
          className={css.img}
        />
      );
    }
  }

  return (
    <li className={`${css.main} ${center ? css.center : ""}`}>
      <div
        className={`${css.container} ${type ? css[`container_${type}`] : ""}`}
      >
        {icon}
      </div>
      <div className={css.children}>{children}</div>
    </li>
  );
};

export default LI;
